export const termsVersion = '2026-10-21'

export type TermsSection = { title: string; paragraphs: string[] }

const en: TermsSection[] = [
  {
    title: '1. General',
    paragraphs: [
      'These terms govern your use of the partner space and the Agent SDK. By accepting them you confirm that you act on behalf of the partner company and are authorised to accept these terms.',
      'If you do not agree, you can keep using the partner space to view information, but you will not be able to submit builds for moderation, open the SDK, or get the Grafana plugin.',
    ],
  },
  {
    title: '2. Distributing the SDK',
    paragraphs: [
      'The partner embeds the Agent SDK only in applications it has the right to distribute, and only with the explicit consent of the device’s end user.',
      'When the partner’s application that integrates the proxy SDK starts on a device, it must explicitly ask the end user whether they agree that their device becomes part of a residential proxy network, and must not share the device’s connection until the user has agreed. This request is mandatory: it cannot be skipped, preselected, or hidden inside the application’s general terms or privacy policy.',
      'The partner must tell users plainly that the application shares their network connection, and let them switch that off at any time.',
    ],
  },
  {
    title: '3. Build moderation',
    paragraphs: [
      'Every build submitted for moderation is scanned by antivirus engines. A build’s hash is registered in CRM only when the scan finds no threats.',
      'The partner does not try to get around the scan: no packers that hide code, and no swapping a scanned build for a different one.',
      'Uploaded files are kept for a limited time and are never served back to the partner or to third parties.',
    ],
  },
  {
    title: '4. Prohibited use',
    paragraphs: [
      'The SDK must not be distributed with malicious code, ad fraud, traffic inflation, or in any other way that breaks the law or users’ rights.',
      'If these terms are broken, the partner account may be suspended and its registered agent hashes revoked.',
    ],
  },
  {
    title: '5. Data and privacy',
    paragraphs: [
      'We process data about connected agents and traffic only for accounting, statistics, and settlement with the partner.',
      'The partner does not share its partner key or partner space credentials with third parties and is responsible for anything done with them.',
    ],
  },
  {
    title: '6. Liability',
    paragraphs: [
      'The service is provided as is. We aim for uninterrupted operation but do not guarantee it, including when CRM or third-party scanning services are unavailable.',
    ],
  },
  {
    title: '7. Changes to these terms',
    paragraphs: [
      'We may update these terms. A new version is shown when you next enter the partner space, and you will need to accept it again to use moderation, the SDK, and the Grafana plugin.',
    ],
  },
]

export const termsSections = (): TermsSection[] => en
